/**
 * A-Z về mắt
 */

import ListSlider from './ListSlider';
import CopyToClipboard from './CopyToClipboard';

export default function Topics() {
    const selectors = {
        'wrapper' : '.js-topics-wrapper',
        'form' : '.js-filter-topics-form',
        'result' : '.js-topics-results',
        'related' : '.js-topics-related',
        'pagination' : '.js-topics-pagination',
    };

    this.init = () => {
        let $form = jQuery(selectors.form);
        if (!$form.length) return;
        this.handleForm();
        this.display(jQuery(selectors.form));
        this.handlePagination();
    }

    this.template = () => {
        let compiled = null;
    
        compiled = _.template(
            '<div class="w-full relative h-0 pt-[57.58%] rounded-20px overflow-hidden">\n' +
            '    <img class="absolute bg-primary-light inset-0 w-full h-full object-cover" src="<%= image_url %>" width="521" height="300" alt="<%= name %>">\n' +
            '    <div class="absolute z-1 inset-0 w-full h-full xl:p-10 p-7 flex flex-col xl:justify-start justify-center">\n' +
            '        <p class="fieldstyle text-white font-medium lg:text-22px text-xl leading-tight uppercase">\n' +
            '            <%= title_other %>\n' +
            '        </p>\n' +
            '        <div class="xl:mt-5 mt-2.5">\n' +
            '            <a href="<%= url %>" \n' +
            '                class=" bg-white hover:bg-button-hover text-primary text-xs -tracking-button leading-tight inline-flex flex-row items-center py-1.5 md:px-6 px-4 rounded-10px gap-6px font-medium border border-primary transition-colors duration-400">\n' +
            '                Xem chi tiết\n' +
            '            </a>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '</div>');
        return compiled;
    }

    this.templatePost = () => {
        let compiled = null;
    
        compiled = _.template(
            '<div class="group flex flex-col">\n' +
            '    <a class="relative block w-full h-0 pt-[64.32%] shadow-md rounded-10px overflow-hidden" href="<%= url %>">\n' +
            '        <img class="absolute inset-0 w-full h-full object-cover" src="<%= image_url %>" width="269" height="269" alt="">\n' +
            '    </a>\n' +
            '    <p class="md:mt-4 mt-2 text-primary font-normal text-base"><time datetime="<%= date_time %>"><%= date_time %></time></p>\n' +
            '    <p class="md:mt-2.5 mt-1 fieldstyle text-black font-medium md:text-xl text-lg leading-tight">\n' +
            '        <a class="text-black group-hover:text-primary" href="<%= url %>">\n' +
            '            <%= name %>\n' +
            '        </a>\n' +
            '    </p>\n' +
            '</div>\n'
        );


        return compiled;
    }

    this.templateDetail = () => {
        let compiled = null;
    
        compiled = _.template(
            '<div class="max-w-[853px] mx-auto">\n' +
            '    <div class="wysiwyg sm:text-base text-sm font-normal text-black">\n' +
            '        <%= post_content %>\n' +
            '    </div>\n' +
            '    <div class="mt-10">\n' +
            '        \n' +
            '    </div>\n' +
            '    <div class="mt-10"><%= share_socials %></div>\n' +
            '</div>'
        );


        return compiled;
    }

    this.templateRelated = (url, resultsData) => {
        let postTemplate = _.template(
            '<div class="lg:pb-100px pb-60px ">\n' +
            '    <div class="container mx-auto">\n' +
            '        <p class="lg:mb-10 mb-6 font-medium text-primary md:text-40px text-[28px] text-center">\n' +
            '            Nội dung liên quan\n' +
            '        </p>\n' +
            '        <div class="block w-full" data-group-swiper="topics-related">\n' +
            '            <div class="swiper mx-auto md:max-w-full">\n' +
            '                <div class="swiper-wrapper">\n' +
            '                    <%= results %>\n' +
            '                </div>\n' +
            '            </div>\n' +
            '        </div>\n' +
            '        <div class="md:mt-10 mt-4 flex justify-center text-center">\n' +
            '            <a href="<%= url %>" \n' +
            '                class="bg-white hover:bg-button-hover text-primary md:text-base text-sm -tracking-button leading-tight flex flex-row items-center py-1.5 md:px-6 px-4 rounded-30px gap-6px font-medium border border-primary transition-colors duration-400">\n' +
            '                Xem tất cả\n' +
            '                <svg fill=none height=15 viewBox="0 0 15 15"width=15 xmlns=http://www.w3.org/2000/svg><path d="M4.89844 12.2226V7.42258C4.89844 5.82257 6.14634 4.5918 7.63194 4.5918H12.267C13.812 4.5918 15.0005 5.88411 15.0005 7.42258C15.0005 9.02259 13.7526 10.2534 12.267 10.2534H10.4249V12.1611C10.4249 13.7611 9.17696 14.9919 7.69137 14.9919C6.14635 15.1149 4.89844 13.8226 4.89844 12.2226ZM7.62458 5.4964C6.61437 5.4964 5.7898 6.37642 5.7898 7.42258V12.2226C5.7898 13.2688 6.62173 14.1303 7.63194 14.1303C8.64215 14.1303 9.47408 13.2688 9.47408 12.2226V9.39182H12.2076C13.2178 9.39182 14.0497 8.53028 14.0497 7.48412C14.0497 6.43796 13.2178 5.4964 12.2076 5.4964H7.63194H7.62458Z"fill=#0B9446 /><path d="M0 7.36856C0 8.91358 1.28572 10.1021 2.81634 10.1021H7.59185C9.18369 10.1021 10.4082 8.85416 10.4082 7.36856V2.7335C10.4082 1.18848 9.12246 0 7.59185 0C6.00001 0 4.77551 1.2479 4.77551 2.7335V4.57564H2.87756C1.28572 4.63506 0 5.82354 0 7.36856ZM5.69388 5.52642V2.79292C5.69388 1.78272 6.55103 0.950783 7.59185 0.950783C8.63266 0.950783 9.48981 1.78272 9.48981 2.79292V7.42798C9.48981 8.43819 8.63266 9.27013 7.59185 9.27013H2.81634C1.77552 9.27013 0.918369 8.43819 0.918369 7.42798C0.918369 6.41778 1.77552 5.58585 2.81634 5.58585H5.69388V5.52642Z"fill=#0B9446 /></svg>\n' +
            '            </a>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '</div>\n'
        );

        let resultTemplate = _.template(
            '<div class="swiper-slide">\n' +
            '   <div class="group flex flex-col">\n' +
            '       <a class="relative block w-full h-0 pt-[64.32%] shadow-md rounded-10px overflow-hidden" href="<%= result.url %>">\n' +
            '           <img class="absolute inset-0 w-full h-full object-cover" src="<%= result.image_url %>" width="269" height="269" alt="">\n' +
            '       </a>\n' +
            '       <p class="mt-4 text-primary font-normal text-base"><time datetime="<%= result.date_time %>"><%= result.date_time %></time></p>\n' +
            '       <p class="mt-2.5 fieldstyle text-black font-medium md:text-xl text-lg leading-tight">\n' +
            '           <a class="text-black group-hover:text-primary" href="<?php echo get_permalink( get_the_ID() ); ?>">\n' +
            '               <%= result.name %>\n' +
            '           </a>\n' +
            '       </p>\n' +
            '   </div>\n' +
            '</div>\n'
        );

        let resultsHtml = '';
        resultsData.forEach(function(resultItem) {
            resultsHtml += resultTemplate({ result: resultItem });
        });
    
        let termHtml = postTemplate({
            url: url,
            results: resultsHtml
        });
    
        return termHtml;
    }

    this.templateType1 = () => {
        let compiled = null;

        compiled = _.template(
            '<div class="group relative max-w-full mx-auto w-full h-auto">\n' +
            '    <a href="<%= url %>" title="<%= name %>" class="block w-full">\n' +
            '        <svg class="w-full h-auto" width="296" height="248" viewBox="0 0 296 248" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
            '            <path d="M17.7496 0.769531H278.146C287.665 0.769531 295.397 8.76958 295.5 18.7108C295.5 18.7118 295.5 18.7128 295.5 18.7138L295.5 197.488C295.5 205.797 289.026 212.39 281.174 212.39H200.3C197.139 212.39 192.975 212.875 189.59 215.123C186.167 217.395 183.621 221.414 183.621 228.292C183.621 234.942 181.845 239.291 179.15 241.979C176.453 244.668 172.761 245.77 168.777 245.77H17.7496C8.22903 245.77 0.5 237.768 0.5 227.83V18.7087C0.5 8.77093 8.22903 0.769531 17.7496 0.769531Z" fill="url(#pattern1_2195_7885_<%= slug %>)" stroke="#0B9446" stroke-miterlimit="10"/>\n' +
            '            <defs>\n' +
            '            <pattern id="pattern1_2195_7885_<%= slug %>" patternContentUnits="objectBoundingBox" width="1" height="1">\n' +
            '                <use xlink:href="#image1_2195_7885_<%= slug %>" transform="matrix(0.000615006 0 0 0.000740007 0 -0.000615006)"/>\n' +
            '            </pattern>\n' +
            '            <image id="image1_2195_7885_<%= slug %>" width="1626" height="1353" \n' +
            '                xlink:href="<%= image_url %>"/>\n' +
            '            </defs>\n' +
            '        </svg>\n' +
            '    </a>\n' +
            '    \n' +
            '    <div class="button absolute w-[37%] h-[12%] bottom-2px right-0 ">\n' +
            '        <a href="<%= url %>" class="w-full h-full text-xs bg-white border border-primary rounded-11px py-5px px-5 flex justify-center items-center text-center text-primary transition-colors duration-400 whitespace-nowrap">Xem chi tiết</a>\n' +
            '    </div>\n' +
            '</div>\n'
        );
        return compiled;
    }

    this.templateType2 = () => {
        let compiled = null;

        compiled = _.template(
            '<div class="w-full relative h-0 pt-[57.58%] rounded-20px overflow-hidden">\n' +
            '    <img class="absolute bg-primary-light inset-0 w-full h-full object-cover" src="<%= image_url %>" width="521" height="300" alt="<%= name %>">\n' +
            '    <div class="absolute z-1 inset-0 w-full h-full xl:p-10 p-7 flex flex-col xl:justify-start justify-center">\n' +
            '        <p class="fieldstyle text-white font-medium lg:text-22px text-xl leading-tight uppercase">\n' +
            '            <%= title_other || name %>\n' +
            '        </p>\n' +
            '        <div class="xl:mt-5 mt-2.5">\n' +
            '            <a href="<%= url %>" \n' +
            '                class=" bg-white hover:bg-button-hover text-primary text-xs -tracking-button leading-tight inline-flex flex-row items-center py-1.5 md:px-6 px-4 rounded-10px gap-6px font-medium border border-primary transition-colors duration-400">\n' +
            '                Xem chi tiết\n' +
            '            </a>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '</div>\n'
        );
        return compiled;
    }

    this.templateType3 = (termData, resultsData) => {
        let resultTemplate = _.template(
            '<div class="swiper-slide">\n' +
            '    <div class="group flex flex-col">\n' +
            '        <a class="relative block w-full h-0 pt-[64.32%] shadow-md rounded-10px overflow-hidden" href="<%= result.url %>">\n' +
            '            <img class="absolute inset-0 w-full h-full object-cover" src="<%= result.image_url %>" width="269" height="269" alt="">\n' +
            '        </a>\n' +
            '        <p class="mt-4 text-primary font-normal text-base"><time datetime="<%= result.date_time %>"><%= result.date_time %></time></p>\n' +
            '        <p class="mt-2.5 fieldstyle text-black font-medium md:text-xl text-lg leading-tight">\n' +
            '            <a class="text-black group-hover:text-primary" href="<%= result.url %>">\n' +
            '                <%= result.name %>\n' +
            '            </a>\n' +
            '        </p>\n' +
            '    </div>\n' +
            '</div>\n'
        );
    
        let termTemplate = _.template(
            '<div class="first:mt-0 mt-60px relative">\n' +
            '    <div class="flex w-full items-center gap-4 md:pr-36">\n' +
            '        <div class="inline-flex flex-col sm:flex-row sm:items-center">\n' +
            '            <a class="mr-5 inline-block h-10 md:h-60px w-auto" href="<%= term.url %>">\n' +
            '                <img class="h-full w-auto block object-contain" src="<%= term.icon %>" alt="">\n' +
            '            </a>\n' +
            '            <h2 class="mt-2 sm:mt-0 text-primary font-medium text-[26px] md:text-4xl">\n' +
            '                <a class="" href="<%= term.url %>">\n' +
            '                    <%= term.name %>\n' +
            '                </a>\n' +
            '            </h2>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '    <div class="mt-5 md:mt-10 relative" data-group-swiper="topics" data-value-swiper="width">\n' +
            '        <div class="swiper" data-swiper_json="">\n' +
            '            <div class="swiper-wrapper">\n' +
            '                <%= results %>\n' +
            '            </div>\n' +
            '        </div>\n' +
            '        <div class="swiper-button-prev"></div>\n' +
            '        <div class="swiper-button-next"></div>\n' +
            '    </div>\n' +
            '    <div class="mt-6 md:mt-10 lg:mt-0 flex justify-center static md:absolute md:top-[30px] md:right-0 md:-translate-y-1/2">\n' +
            '        <a href="<%= term.url %>" \n' +
            '            class="bg-white hover:bg-button-hover text-primary md:text-base text-sm -tracking-button leading-tight inline-flex flex-row items-center py-1.5 md:px-6 px-4 rounded-30px gap-6px font-medium border border-primary transition-colors duration-400">\n' +
            '            Xem tất cả \n' +
            '            <svg fill=none height=15 viewBox="0 0 15 15"width=15 xmlns=http://www.w3.org/2000/svg><path d="M4.89844 12.2226V7.42258C4.89844 5.82257 6.14634 4.5918 7.63194 4.5918H12.267C13.812 4.5918 15.0005 5.88411 15.0005 7.42258C15.0005 9.02259 13.7526 10.2534 12.267 10.2534H10.4249V12.1611C10.4249 13.7611 9.17696 14.9919 7.69137 14.9919C6.14635 15.1149 4.89844 13.8226 4.89844 12.2226ZM7.62458 5.4964C6.61437 5.4964 5.7898 6.37642 5.7898 7.42258V12.2226C5.7898 13.2688 6.62173 14.1303 7.63194 14.1303C8.64215 14.1303 9.47408 13.2688 9.47408 12.2226V9.39182H12.2076C13.2178 9.39182 14.0497 8.53028 14.0497 7.48412C14.0497 6.43796 13.2178 5.4964 12.2076 5.4964H7.63194H7.62458Z"fill=#0B9446 /><path d="M0 7.36856C0 8.91358 1.28572 10.1021 2.81634 10.1021H7.59185C9.18369 10.1021 10.4082 8.85416 10.4082 7.36856V2.7335C10.4082 1.18848 9.12246 0 7.59185 0C6.00001 0 4.77551 1.2479 4.77551 2.7335V4.57564H2.87756C1.28572 4.63506 0 5.82354 0 7.36856ZM5.69388 5.52642V2.79292C5.69388 1.78272 6.55103 0.950783 7.59185 0.950783C8.63266 0.950783 9.48981 1.78272 9.48981 2.79292V7.42798C9.48981 8.43819 8.63266 9.27013 7.59185 9.27013H2.81634C1.77552 9.27013 0.918369 8.43819 0.918369 7.42798C0.918369 6.41778 1.77552 5.58585 2.81634 5.58585H5.69388V5.52642Z"fill=#0B9446 /></svg>\n' +
            '        </a>\n' +
            '    </div>\n' +
            '</div>\n'
        );
    
        let resultsHtml = '';
        resultsData.forEach(function(resultItem) {
            resultsHtml += resultTemplate({ result: resultItem });
        });
    
        let termHtml = termTemplate({
            term: termData,
            results: resultsHtml
        });
    
        return termHtml;
    }

    this.templateType4 = (termData, resultsData) => {
        let resultTemplate = _.template(
            '<div class="swiper-slide">\n' +
            '    <div class="group flex flex-col">\n' +
            '        <a class="relative block w-full h-0 pt-[64.32%] shadow-md rounded-10px overflow-hidden" href="<%= result.url %>">\n' +
            '            <img class="absolute inset-0 w-full h-full object-cover" src="<%= result.image_url %>" width="269" height="269" alt="">\n' +
            '        </a>\n' +
            '        <p class="mt-4 text-primary font-normal text-base"><time datetime="<%= result.date_time %>"><%= result.date_time %></time></p>\n' +
            '        <p class="mt-2.5 fieldstyle text-black font-medium md:text-xl text-lg leading-tight">\n' +
            '            <a class="text-black group-hover:text-primary" href="<%= result.url %>">\n' +
            '                <%= result.name %>\n' +
            '            </a>\n' +
            '        </p>\n' +
            '    </div>\n' +
            '</div>\n'
        );
    
        let termTemplate = _.template(
            '<div class="first:mt-0 mt-60px relative">\n' +
            '    <div class="flex w-full items-center gap-4 md:pr-36">\n' +
            '        <div class="inline-flex flex-col sm:flex-row sm:items-center">\n' +
            '            <a class="inline-block h-10 md:h-60px w-auto" href="<%= term.url %>">\n' +
            '                <img class="h-full w-auto block object-contain" src="<%= term.icon %>" alt="">\n' +
            '            </a>\n' +
            '            <h2 class="mt-2 sm:mt-0 sm:ml-5 text-primary font-medium text-[26px] md:text-4xl">\n' +
            '                <a class="" href="<%= term.url %>">\n' +
            '                    <%= term.name %>\n' +
            '                </a>\n' +
            '            </h2>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '    <div class="mt-5 md:mt-10 relative" data-group-swiper="topics-2" data-value-swiper="width">\n' +
            '        <div class="swiper" data-swiper_json="">\n' +
            '            <div class="swiper-wrapper">\n' +
            '                <%= results %>\n' +
            '            </div>\n' +
            '        </div>\n' +
            '        <div class="swiper-button-prev"></div>\n' +
            '        <div class="swiper-button-next"></div>\n' +
            '    </div>\n' +
            '    <div class="mt-6 md:mt-10 lg:mt-0 flex justify-center static md:absolute md:top-[30px] md:right-0 md:-translate-y-1/2">\n' +
            '        <a href="<%= term.url %>" \n' +
            '            class="bg-white hover:bg-button-hover text-primary md:text-base text-sm -tracking-button leading-tight inline-flex flex-row items-center py-1.5 md:px-6 px-4 rounded-30px gap-6px font-medium border border-primary transition-colors duration-400">\n' +
            '            Xem tất cả \n' +
            '            <svg fill=none height=15 viewBox="0 0 15 15"width=15 xmlns=http://www.w3.org/2000/svg><path d="M4.89844 12.2226V7.42258C4.89844 5.82257 6.14634 4.5918 7.63194 4.5918H12.267C13.812 4.5918 15.0005 5.88411 15.0005 7.42258C15.0005 9.02259 13.7526 10.2534 12.267 10.2534H10.4249V12.1611C10.4249 13.7611 9.17696 14.9919 7.69137 14.9919C6.14635 15.1149 4.89844 13.8226 4.89844 12.2226ZM7.62458 5.4964C6.61437 5.4964 5.7898 6.37642 5.7898 7.42258V12.2226C5.7898 13.2688 6.62173 14.1303 7.63194 14.1303C8.64215 14.1303 9.47408 13.2688 9.47408 12.2226V9.39182H12.2076C13.2178 9.39182 14.0497 8.53028 14.0497 7.48412C14.0497 6.43796 13.2178 5.4964 12.2076 5.4964H7.63194H7.62458Z"fill=#0B9446 /><path d="M0 7.36856C0 8.91358 1.28572 10.1021 2.81634 10.1021H7.59185C9.18369 10.1021 10.4082 8.85416 10.4082 7.36856V2.7335C10.4082 1.18848 9.12246 0 7.59185 0C6.00001 0 4.77551 1.2479 4.77551 2.7335V4.57564H2.87756C1.28572 4.63506 0 5.82354 0 7.36856ZM5.69388 5.52642V2.79292C5.69388 1.78272 6.55103 0.950783 7.59185 0.950783C8.63266 0.950783 9.48981 1.78272 9.48981 2.79292V7.42798C9.48981 8.43819 8.63266 9.27013 7.59185 9.27013H2.81634C1.77552 9.27013 0.918369 8.43819 0.918369 7.42798C0.918369 6.41778 1.77552 5.58585 2.81634 5.58585H5.69388V5.52642Z"fill=#0B9446 /></svg>\n' +
            '        </a>\n' +
            '    </div>\n' +
            '</div>\n'
        );
    
        let resultsHtml = '';
        resultsData.forEach(function(resultItem) {
            resultsHtml += resultTemplate({ result: resultItem });
        });
    
        let termHtml = termTemplate({
            term: termData,
            results: resultsHtml
        });
    
        return termHtml;
    }

    this.useType = (type, res) => {
        const data = res.data;
        let container = jQuery("<div></div>");

        if (type === 1){
            container = jQuery('<div class="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 xl:gap-x-[48px] md:gap-x-6 sm:gap-x-4 xl:gap-y-10 sm:gap-y-4 gap-y-10"></div>')
            data.forEach(item => {
                const itemTemplate = this.templateType1();
                container.append(itemTemplate(item['term']));
            });
        } else if (type == 2){
            container = jQuery('<div class="grid md:grid-cols-2 xl:gap-[46px] md:gap-5 gap-y-10"></div>')
            data.forEach(item => {
                const itemTemplate = this.templateType2();
                container.append(itemTemplate(item['term']));
            });
        } else if (type === 3){
            container = jQuery('<div></div>');
            data.forEach(item => {
                const title = item['term'];
                const results = item['results'];

                if (title){
                    let itemTemplate = this.templateType3(title, results);
                    container.append(itemTemplate);
                }else if (results){
                    if (res.meta.total == 1 && results.length == 1){
                        container.append(this.createDetailContainer(results[0]));
                    }else{
                        container.append(this.createPostsContainer(results));
                    }
                }
            })
        }

        else if (type === 4){
            container = jQuery('<div></div>');
            data.forEach(item => {
                const title = item['term'];
                const results = item['results'];

                if (title){
                    let itemTemplate = this.templateType4(title, results);
                    container.append(itemTemplate);
                }else if (results){
                    if (res.meta.total == 1 && results.length == 1){
                        container.append(this.createDetailContainer(results[0]));
                    }else{
                        container.append(this.createPostsContainer(results));
                    }
                }
            })
        }

        return container;
    }

    this.getAllTopics = async (search, paged = 1) => {
        return jQuery.ajax({
            type : "GET",
            dataType : "JSON",
            // url : theme_object.endpoint_url + 'topics_taxes',
            url : theme_object.endpoint_url + 'topics/taxes',
            data : {
                q: search,
                paged: paged,
            },
            context: this
        })
    }

    this.getPostsTopicsByTermSlug = async (search, term_slug, paged = 1) => {
        return jQuery.ajax({
            type : "GET",
            dataType : "JSON",
            url : theme_object.endpoint_url + `topics/taxes/${term_slug}`,
            data : {
                q: search,
                paged: paged,
            },
            context: this
        })
    }
    
    this.getAllPostsTopicsByTermSlug = async (search, term_slug, paged = 1) => {
        return jQuery.ajax({
            type : "GET",
            dataType : "JSON",
            // url : theme_object.endpoint_url + 'topics_tax_posts',
            url : theme_object.endpoint_url + `topics/taxes/${term_slug}/posts`,
            data : {
                q: search,
                paged: paged,
            },
            context: this
        })
    }

    this.handleForm = async () => {
        jQuery(selectors.form).on('submit', async (e) => {
            e.preventDefault(); 

            let $this = jQuery(e.target);
            $this.find('[name="paged"]').val(1)
            this.display($this);
            
            return false;
        })
    }

    function sanitizeString(value) {
        if (typeof value === 'string') {
            return value.trim()
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/[^a-zA-Z0-9-_]/g, ''); 
        }
        return ''; 
    }
    function sanitizeInteger(value, defaultValue = 0) {
        const num = parseInt(value, 10);
        return isNaN(num) ? defaultValue : num;
    }

    this.display = async ($form) => {        
        const searchInput = $form.find('[name="search"]');
        const search = searchInput.length ? encodeURIComponent(searchInput.val()) : '';
        
        const paged = sanitizeInteger($form.find('[name="paged"]').val());
        const type = sanitizeInteger($form.find('[name="type"]').val());
        const term_slug = sanitizeString($form.data('term'));

        const wrapper = jQuery(selectors.wrapper);
        wrapper.find('.js-overlay').css({"display":"flex"});
        
        try {
            let res;
            if (term_slug) {
                if (type === 0) {
                    res = await this.getAllPostsTopicsByTermSlug(search, term_slug, paged);
                    this.handleTermResults(res, $form);
                } else {
                    res = await this.getPostsTopicsByTermSlug(search, term_slug, paged);
                    this.handleTypeResults(res, type, $form);
                }
            }else{
                res = await this.getAllTopics(search, paged);
                this.handleAllTopicsResults(res, $form);
            }
        } catch (error){
            console.error("ERROR fetching data:", error);
        } finally{
            new ListSlider().init();
            new CopyToClipboard().init();
            wrapper.find('.js-overlay').hide();
        }
    }

    this.handleTermResults = (res, $form) => {
        if (res.data) {
            const resultsDom = jQuery(selectors.wrapper).find(selectors.result);
            resultsDom.empty();
    
            let container = jQuery('<div class=""></div>');
            res.data.forEach(item => {
                const results = item['results'];
                container = results.length === 1 
                    ? this.createDetailContainer(results[0]) 
                    : this.createPostsContainer(results);
                resultsDom.append(container);
            });
    
            this.handleRelatedContent(res.data);
            this.updatePagination(res.meta, $form);
        }
    }
    
    this.handleTypeResults = (res, type, $form) => {
        if (res.data) {
            const resultsDom = jQuery(selectors.wrapper).find(selectors.result);
            resultsDom.empty();
            const htmlContainer = this.useType(type, res);
            resultsDom.append(htmlContainer);
            this.handleRelatedContent(res.data);
            this.updatePagination(res.meta, $form);
        }
    }
    
    this.handleAllTopicsResults = (res, $form) => {
        if (res.data) {
            const resultsDom = jQuery(selectors.wrapper).find(selectors.result);
            resultsDom.empty();
            const itemTemplate = this.template();
            res.data.forEach(item_data => {
                if (!item_data['title_other']) {
                    item_data['title_other'] = item_data['name'];
                }
                if (!item_data['image_url']) { item_data['image_url'] = ''; }
                resultsDom.append(itemTemplate(item_data));
            });
            this.updatePagination(res.meta, $form);
        }
    }
    
    this.createDetailContainer = (item_data) => {
        const container = jQuery('<div class=""></div>');
        const itemTemplate = this.templateDetail();
        container.append(itemTemplate(item_data));
        return container;
    }
    
    this.createPostsContainer = (results) => {
        const container = jQuery('<div class="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 xl:gap-x-60px md:gap-x-8 sm:gap-x-4 md:gap-y-10 gap-y-6"></div>');
        const itemTemplate = this.templatePost();
        
        results.forEach(item_data => {
            container.append(itemTemplate(item_data));
        });
    
        return container;
    }
    
    this.handleRelatedContent = (data) => {
        if (data.length === 1 && data[0].related) {
            const relatedDom = jQuery(selectors.related);
            const related = data[0].related;
            const itemTemplate = this.templateRelated(related['url'], related['posts']);
            relatedDom.append(itemTemplate);
        }
    }
    
    this.updatePagination = (meta, $form) => {
        if (meta) {
            $form.find('[name="paged"]').val(meta.current_page);
            $form.find('[name="total_pages"]').val(meta.total_pages);
            
            if (meta.total_pages === 1) {
                jQuery(selectors.pagination).hide();
            } else {
                jQuery(selectors.pagination).css('display', '');
                jQuery(selectors.pagination).html(this.pagination(meta.current_page, meta.total_pages));
            }
        }
    }

    this.handlePagination = () => {
        jQuery(selectors.pagination).on('click', 'a[data-page]', (e) => {
            e.preventDefault();
            let $this = jQuery(e.currentTarget);
            let $form = jQuery(selectors.form);
            let paged = $this.attr('data-page');
            $form.find('[name="paged"]').val(parseInt(paged))
            this.display($form);
        })
    }

    this.handleForm = async () => {
        jQuery(selectors.form).on('submit', async (e) => {
            e.preventDefault();

            let $this = jQuery(e.target);
            $this.find('[name="paged"]').val(1)
            this.display($this);

            return false;
        })
    }

    this.pagination = (currentPage, totalPages) => {
        if (totalPages == 1) 
            
            return '';

        let paginationHTML = '';
        let display;
        let next = '<svg fill=none height=14 viewBox="0 0 8 14"width=8 xmlns=http://www.w3.org/2000/svg><path d="M1.01341 1L7 7L1.01341 13"stroke=#4D5761 stroke-linecap=round /></svg>'
        let prev = '<svg fill=none height=14 viewBox="0 0 8 14"width=8 xmlns=http://www.w3.org/2000/svg><path d="M6.98659 1L1 7L6.98659 13"stroke=#4D5761 stroke-linecap=round /></svg>'
        // Previous button
        if (currentPage > 1) {
            paginationHTML += `<a href="#" data-page="${currentPage - 1}" class="prev md:mr-10">${prev}</a>`;
        }

        // First page
        if (currentPage > 2) {
            paginationHTML += `<a href="#" data-page="1" class="text-lg text-gray-600 leading-tight font-light">01</a>`;
        }

        // Ellipsis before current page range
        if (currentPage > 3) {
            paginationHTML += `<span class="dots text-lg text-gray-600 leading-tight font-light">...</span>`;
        }

        // Page numbers around the current page
        let startPage = Math.max(1, currentPage - 1);
        let endPage = Math.min(totalPages, currentPage + 1);

        for (let i = startPage; i <= endPage; i++) {
            display = i;
            if(i<10 && i > 0) {
                display = '0'+i;
            }
            if (i === currentPage) {
                paginationHTML += `<span class="active text-lg text-primary leading-tight font-medium">${display}</span>`;
            } else {
                paginationHTML += `<a href="#" data-page="${i}" class="text-lg text-gray-600 leading-tight font-light">${display}</a>`;
            }
        }

        // Ellipsis after current page range
        if (currentPage < totalPages - 2) {
            paginationHTML += `<span class="dots text-lg text-gray-600 leading-tight font-light">...</span>`;
        }

        // Last page
        if (currentPage < totalPages - 1) {
            display = totalPages;
            if(totalPages < 10 && totalPages > 0) {
                display = '0'+totalPages;
            }
            paginationHTML += `<a href="#" data-page="${totalPages}" class="text-lg text-gray-600 leading-tight font-light">${display}</a>`;
        }

        // Next button
        if (currentPage < totalPages) {
            paginationHTML += `<a href="#" data-page="${currentPage + 1}" class="next md:ml-10">${next}</a>`;
        }

        return paginationHTML;
    }

}
